import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import style from "styled-components";
import {setSelectedCardId} from "../../../store/stakingStore";
import {useEthers} from "@usedapp/core";
import BigNumber from "bignumber.js";
import {AiOutlineQuestionCircle} from "react-icons/ai";
import styles from "./footer.module.scss";

function CardFooter({stackingPool, findItem, stakedAmount}) {
  const dispatch = useDispatch();
  const stackingPoolId = stackingPool?.id;
  const {selectedCardObj, contract} = useSelector(
    (state) => state.stakingSlice
  );

  const depositFee = stackingPool?.depositFee?.toString();
  const withdrawFee = stackingPool?.withdrawFee?.toString();
  const emergencyWithdrawFee = stackingPool?.emergencyWithdrawFee?.toString();
  const [poolMinValue, setPoolMinValue] = useState(null);
  const [poolMaxValue, setPoolMaxValue] = useState(null);
  const [hide, setHide] = useState(true);

  const {account} = useEthers();
  const totalBalance = useSelector((state) => state.stakingSlice.totalBalance);

  const stakedTokenAmount = new BigNumber(stakedAmount)
    .dividedBy(Math.pow(10, 9))
    .toNumber()
    .toFixed(2);
  const realTokenAmount = new BigNumber(totalBalance)
    .dividedBy(Math.pow(10, 9))
    .toNumber()
    .toLocaleString("en", {useGrouping: true});
  const handleShow = (stackingPool) => {
    setHide(!hide);
    const selectedObj = {
      id: stackingPool?.id,
      isFixed: stackingPool?.isFixed,
    };
    if (
      selectedCardObj?.id === stackingPool?.id &&
      selectedCardObj?.isFixed === stackingPool?.isFixed
    ) {
      return dispatch(setSelectedCardId(null));
    }
    dispatch(setSelectedCardId(selectedObj));
  };

  useEffect(() => {
    const getMinAndMaxValues = async () => {
      const minValue = await contract.minAmount();
      setPoolMinValue(
        Number(minValue.toString() / Math.pow(10, 9)).toLocaleString("en", {
          useGrouping: true,
        })
      );
      const maxValue = await contract.maxAmount();
      setPoolMaxValue(
        Number(maxValue.toString() / Math.pow(10, 9)).toLocaleString("en", {
          useGrouping: true,
        })
      );
    };
    getMinAndMaxValues();
  }, [contract]);

  return (
    <>
      <ContainerSpaceBetween>
        <DetailsText>Pool Id: {stackingPoolId}</DetailsText>
        <DetailsTextClickable
          className={!hide && styles.hideButton}
          onClick={() => handleShow(stackingPool)}
        >
          Details
        </DetailsTextClickable>
      </ContainerSpaceBetween>
      {selectedCardObj?.id === stackingPool?.id &&
        selectedCardObj?.isFixed === stackingPool?.isFixed && (
          <UpperContainer>
            <div
              className={`${styles.titleContainer} ${
                !findItem?.amount.toString() > 0 &&
                styles.titleContainerSmallCard
              }`}
            >
              <h1>POOL INFO</h1>
              <div className={styles.icon}>
                <AiOutlineQuestionCircle />
              </div>
            </div>
            <div>
              <DetailContainerSpaceBetween>
                <CardDetailedText>Your Balance:</CardDetailedText>
                <CardDetailedText>{realTokenAmount} SHINO</CardDetailedText>
              </DetailContainerSpaceBetween>

              <DetailContainerSpaceBetween>
                <CardDetailedText>Pool Status:</CardDetailedText>
                {stackingPool.isOpen ? (
                  <CardDetailedText>Active</CardDetailedText>
                ) : (
                  <CardDetailedText>Not Active</CardDetailedText>
                )}
              </DetailContainerSpaceBetween>
              <DetailContainerSpaceBetween>
                <CardDetailedText>Minimum Stake:</CardDetailedText>
                {poolMinValue ? (
                  <CardDetailedText>{poolMinValue}</CardDetailedText>
                ) : (
                  <CardDetailedText>0</CardDetailedText>
                )}
              </DetailContainerSpaceBetween>
              <DetailContainerSpaceBetween>
                <CardDetailedText>Maximum Stake:</CardDetailedText>
                {poolMaxValue ? (
                  <CardDetailedText>{poolMaxValue}</CardDetailedText>
                ) : (
                  <CardDetailedText>0</CardDetailedText>
                )}
              </DetailContainerSpaceBetween>
              <DetailContainerSpaceBetween>
                <CardDetailedText>Deposit Fee:</CardDetailedText>
                <DetailedTextFee>%{depositFee / 100}</DetailedTextFee>
              </DetailContainerSpaceBetween>
              <DetailContainerSpaceBetween>
                <CardDetailedText>Withdraw Fee:</CardDetailedText>
                <DetailedTextFee>%{withdrawFee / 100}</DetailedTextFee>
              </DetailContainerSpaceBetween>
              <DetailContainerSpaceBetween>
                <CardDetailedText>Emergency Fee:</CardDetailedText>
                <DetailedTextFee>%{emergencyWithdrawFee / 100}</DetailedTextFee>
              </DetailContainerSpaceBetween>
            </div>
          </UpperContainer>
        )}
    </>
  );
}

export default CardFooter;

const UpperContainer = style.div`
background: #6a1eff26;
backdrop-filter: blur(15px);
position:absolute;
top:0;
left:0;
width:100%;
height:100%;
border-radius:1.5rem;
display:flex;
flex-direction:column;
padding-top:1rem;
`;

const ContainerSpaceBetween = style.div`
display:flex;
height:10%;
align-items:center;
justify-content: space-between;
padding: 20px;
margin-top: -5px;
`;

const DetailsText = style.span`
color: grey;
font-size: 0.9rem;
`;

const DetailsTextClickable = style.span`
    font-size: 0.8rem;
    cursor:pointer;
    background: rgba(35,147,39,.4);
    color: #fff;
    border:1px solid rgba(41,249,23,1);
    border-radius: 1.5rem;
    padding: 1px 5px;
    box-shadow: 0 0 10px rgb(41 249 23 / 50%);
    transition: all 0.3s ease-in-out;
    z-index: 1;
    &:hover {
      opacity: 0.8;
    }
`;
const DetailContainerSpaceBetween = style.div`
display:flex;
align-items:center;
justify-content: space-between;
padding: 5px 20px;
margin-top: 5px;
`;
const CardDetailedText = style.span`
color: #fdfdfd;
font-size:0.9rem;
`;

const DetailedTextFee = style.span`
color: red;
font-weight:bold;
font-size:0.9rem;
`;
